/**
 * 思念数据本地存储管理服务
 */

const STORAGE_KEY = 'lijia_miss_data'

export default {
  // 保存思念数据
  saveMissData (data) {
    try {
      const missData = {
        receivedMissIntensity: data.receivedMissIntensity || 0,
        receivedMissCount: data.receivedMissCount || 0,
        responseCount: data.responseCount || 0,
        totalMissCount: data.totalMissCount || 127,
        lastUpdateTime: Date.now()
      }
      localStorage.setItem(STORAGE_KEY, JSON.stringify(missData))
      return true
    } catch (error) {
      console.error('保存思念数据失败:', error)
      return false
    }
  },

  // 加载思念数据
  loadMissData () {
    try {
      const data = localStorage.getItem(STORAGE_KEY)
      if (data) {
        const missData = JSON.parse(data)
        // 检查数据是否过期（24小时）
        const now = Date.now()
        const lastUpdate = missData.lastUpdateTime || 0
        const isExpired = (now - lastUpdate) > 24 * 60 * 60 * 1000

        if (isExpired) {
          console.log('思念数据已过期，使用默认值')
          return this.getDefaultData()
        }

        return {
          receivedMissIntensity: missData.receivedMissIntensity || 0,
          receivedMissCount: missData.receivedMissCount || 0,
          responseCount: missData.responseCount || 0,
          totalMissCount: missData.totalMissCount || 127
        }
      }
      return this.getDefaultData()
    } catch (error) {
      console.error('加载思念数据失败:', error)
      return this.getDefaultData()
    }
  },

  // 获取默认数据
  getDefaultData () {
    return {
      receivedMissIntensity: 0,
      receivedMissCount: 0,
      responseCount: 0,
      totalMissCount: 127
    }
  },

  // 清除思念数据
  clearMissData () {
    try {
      localStorage.removeItem(STORAGE_KEY)
      return true
    } catch (error) {
      console.error('清除思念数据失败:', error)
      return false
    }
  },

  // 更新总思念次数
  updateTotalMissCount (count) {
    const data = this.loadMissData()
    data.totalMissCount = count
    return this.saveMissData(data)
  },

  // 增加接收到的思念强度
  incrementReceivedIntensity (amount = 1) {
    const data = this.loadMissData()
    data.receivedMissIntensity = Math.min(data.receivedMissIntensity + amount, 1314)
    data.receivedMissCount += 1
    return this.saveMissData(data)
  },

  // 减少接收到的思念强度
  decrementReceivedIntensity (amount) {
    const data = this.loadMissData()
    data.receivedMissIntensity = Math.max(data.receivedMissIntensity - amount, 0)
    data.responseCount += 1
    return this.saveMissData(data)
  }
}
